import { StripeFinanceTotalsSummary } from "@/features/stripe/components/StripeFinanceTotalsSummary";
import { useStripeFinances } from "@/features/stripe/hooks/stripeQueries";
import { isStripeFinanceAvailable } from "@/features/stripe/utils/stripeMoney";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { Section } from "@/shared/components/ui/Section";
import { SectionAction } from "@/shared/components/ui/SectionAction";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";

interface Props {
  businessId: string;
  userId: string;
  isOwner: boolean;
}

export function DashboardFinanceSummary({ businessId, userId, isOwner }: Props) {
  const finances = useStripeFinances(businessId, userId, isOwner);
  const { goToFinances } = useAppNavigation();
  // Stays hidden unless Stripe is connected, so businesses without Stripe see no extra noise on Home.
  if (!isOwner || !finances.data || !isStripeFinanceAvailable(finances.data.status)) return null;
  const [primary] = finances.data.totals;

  return (
    <Section
      title="This month"
      count="From Stripe"
      action={<SectionAction aria-label="View finances" onClick={goToFinances}>View</SectionAction>}
      card
    >
      {primary
        ? <StripeFinanceTotalsSummary totals={primary} />
        : <EmptyState message="No Stripe payments or payouts this month yet." />}
    </Section>
  );
}
